import * as React from "react";

import "../../../../../../node_modules/malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.css";

import { setUpCustomScrollbarJQuery } from "../../../scripts/calendarJQueryScript";

import { LoadingIcon } from "../../Common/LoadingIcon/LoadingIcon";
import { MonthlyListDays } from "./MonthlyListDays";

import { IEventViewProps } from "../EventView";

export class MonthlyListEventView extends React.Component<IEventViewProps, any> {

  public constructor(props: any, context: any) {
    super(props, context);
  }

  public componentDidMount() {
    setUpCustomScrollbarJQuery(this.props.portletInstanceId);
  }

  public render() {

   // Loading and classnames:
    const isLoading = this.props.numAjaxCallsInProgress > 0;
    const loadingEventsText = this.props.text.eventViews.loadingEvents;

    let calViewClass = "CAL-view";
    if (isLoading) { calViewClass += " disabled"; }

    return (
      <React.Fragment>
        <div className="CAL-displayArea white_bg">
          <div className={calViewClass}>
            <LoadingIcon displayIcon={isLoading} text={loadingEventsText} />
            <MonthlyListDays {...this.props} isLoading={isLoading}/>
           </div>
        </div>
      </React.Fragment>
    );
  }

};
